import { css, cx, etiColors } from '@eti/styles';
import { StackedIcon } from '@eti/components';
import PropTypes from 'prop-types';
import { traveler as travelerUtil } from '@eti/utils';
import { TRAVELER_TYPE_ICON_WIDTH, TRAVELER_TYPE_ICON_SIDE_MARGIN, TRAVELER_INITIALS_ICON_WIDTH, TRAVELER_INITIALS_ICON_SIDE_MARGIN } from '../utils/constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const travelerTypeIconStyles = color => css`
  color: ${color};
  height: 20px;
  margin: 17px ${TRAVELER_TYPE_ICON_SIDE_MARGIN}px;
  width: ${TRAVELER_TYPE_ICON_WIDTH}px;

  svg {
    fill: ${color};
    height: 20px;
    width: ${TRAVELER_TYPE_ICON_WIDTH}px;
  }
`;
const travelerInitialsHolderStyles = css`
  position: relative;
`;
const travelerInitialsIconStyles = color => css`
  height: 24px;
  margin: 15px ${TRAVELER_INITIALS_ICON_SIDE_MARGIN}px;
  width: ${TRAVELER_INITIALS_ICON_WIDTH}px;

  svg {
    fill: ${color};
    height: 24px;
    width: ${TRAVELER_INITIALS_ICON_WIDTH}px;
  }
`;
const travelerInitialsStyles = css`
  color: ${etiColors.white};
  font-weight: 700;
  left: 0;
  position: absolute;
  text-align: center;
  top: 4px;
  width: 100%;
`;
const getIconIdBasedOnAgeTypeAndGender = (ageType, gender) => {
  if (!ageType && !gender) {
    return 'adult-traveler';
  }
  return gender ? travelerUtil.travelerGenderIcons[gender] : travelerUtil.travelerAgeIcons[ageType];
};
const travelerInitialsIcon = initials => /*#__PURE__*/_jsxs("div", {
  className: travelerInitialsHolderStyles,
  children: [/*#__PURE__*/_jsx(StackedIcon, {
    className: travelerInitialsIconStyles(etiColors.grayScale[10]),
    icons: [{
      id: 'circle',
      color: etiColors.grayScale[10]
    }]
  }), /*#__PURE__*/_jsx("span", {
    className: travelerInitialsStyles,
    children: initials
  })]
});
const travelerIconBaseOnAgeTypeAndGender = (ageType, gender, className) => /*#__PURE__*/_jsx(StackedIcon, {
  className: cx(travelerTypeIconStyles(etiColors.grayScale[10]), className),
  color: etiColors.grayScale[10],
  icons: [{
    id: getIconIdBasedOnAgeTypeAndGender(ageType, gender)
  }]
});
const TravelerIcon = _ref => {
  let {
    ageType,
    gender,
    initials,
    className
  } = _ref;
  return initials ? travelerInitialsIcon(initials) : travelerIconBaseOnAgeTypeAndGender(ageType, gender, className);
};
TravelerIcon.propTypes = {
  ageType: PropTypes.string,
  className: PropTypes.string,
  gender: PropTypes.string,
  initials: PropTypes.string
};
export default TravelerIcon;